import { render } from "./RelationPopoverCard.vue?vue&type=template&id=38592fb5"
import script from "./RelationPopoverCard.vue?vue&type=script&lang=ts"
export * from "./RelationPopoverCard.vue?vue&type=script&lang=ts"

import "./RelationPopoverCard.vue?vue&type=style&index=0&id=38592fb5&lang=scss"
script.render = render

export default script